// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"223":"c2acb2ab","453":"d855a71b","603":"9a86874d"}[chunkId] + ".chunk.js";
};